/** ISO 639-1 codes that use right-to-left layout. */
export const RTL_LANGUAGES = ['ar'] as const;

export const isRtlLanguage = (language?: string | null): boolean => {
  if (!language) return false;
  return (RTL_LANGUAGES as readonly string[]).includes(language.toLowerCase());
};

export const getDocumentDirection = (language?: string | null): 'ltr' | 'rtl' =>
  isRtlLanguage(language) ? 'rtl' : 'ltr';

export const getDomDirection = (): 'ltr' | 'rtl' => {
  if (typeof document === 'undefined') return 'ltr';

  const dir =
    document.getElementById('gott')?.getAttribute('dir') ??
    document.documentElement.getAttribute('dir') ??
    document.body?.getAttribute('dir');

  return dir?.toLowerCase() === 'rtl' ? 'rtl' : 'ltr';
};
